import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import { useMapa } from "../../../../contexts/mapaContext";

export default function NewCardConnection(
  { index, connection, onOpen, removeConexao },
  key
) {
  const { elements } = useMapa();
  const theme = useTheme();
  const styles = {
    container: {
      padding: "0px 5px",
      borderRadius: "5px",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 5px  #0000001a",
      border: "none",
      "&::before": {
        display: "none",
      },
      "&:hover": {
        backgroundColor: theme.palette.background.hover,
      },

      p: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
    },
    text: {
      fontSize: "0.9em",
      maxWidth: "200px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };

  const [element, setElement] = useState(null);
  useEffect(() => {
    if (connection !== undefined) {
      let elemnt = elements?.get(connection?.destinationId);

      if (elemnt) {
        setElement(elemnt);
      }
    }
  }, [connection, elements]);

  return (
    <Stack
      key={key}
      direction="row"
      sx={styles.container}
      onClick={() => onOpen?.(index)}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <LinkOutlinedIcon
          sx={{ color: theme.palette.mode === "dark" ? "#565656" : "#9A9A9A" }}
        />
        <Tooltip title={element?.titulo || "Nova Conexão"}>
          <Typography sx={styles.text}>
            {element?.titulo || "Nova Conexão"}
          </Typography>
        </Tooltip>
      </Stack>

      <IconButton
        aria-label="delete"
        onClick={(e) => {
          e.stopPropagation();
          removeConexao(connection?.id);
        }}
      >
        <DeleteIcon fontSize="inherit" />
      </IconButton>
    </Stack>
  );
}
